import request from '../utils/request'


export default {

  // 活动报名
  enrollPromotion: (data: any) => {
    return request({
      url: '/app/promotion/enrollPromotion',
      method: 'post',
      data
    })
  },

  //查询成员列表
  query: (data: any) => {
    return request({
      url: '/app/house/activity/query',
      method: 'post',
      data
    })
  },

  //支付接口
  orderPay: (data: any) => {
    return request({
      url: '/app/promotion/orderPay',
      method: 'post',
      data
    })
  },

  //订单详情
  orderDetail: (data: any) => {
    return request({
      url: '/app/promotion/orderDetail',
      method: 'post',
      data
    })
  },

  //查询支付状态
  payState: (data: any) => {
    return request({
      url: '/pay/queryAliPayState',
      method: 'post',
      data
    })
  }


}
